import JSCookie from 'js-cookie';

const YEAR = 365;
const PREFIX = 'slab-';

const {
  __slab: { HOST },
} = window;
const GLOBAL_DOMAIN = `.${HOST}`;

const fullKey = (key: string) => `${PREFIX}${key}`;
type Config = {
  expires: number;
  isGlobal: boolean;
  isJson: boolean;
  domain?: string;
};

class Cookie<T extends string | object> {
  key: string;
  configs: Config;
  constructor(key: string, configs: Config) {
    this.key = fullKey(key);
    this.configs = configs;
  }

  getDomain() {
    const {
      configs: { isGlobal, domain },
    } = this;
    return isGlobal ? GLOBAL_DOMAIN : domain;
  }

  set(value: T) {
    const {
      configs: { expires },
      key,
    } = this;

    JSCookie.set(
      key,
      typeof value === 'object' ? JSON.stringify(value) : value,
      {
        domain: this.getDomain(),
        expires,
      },
    );
  }

  get(): T | undefined {
    const {
      configs: { isJson },
      key,
    } = this;

    const value = JSCookie.get(key);

    if (isJson && value) {
      try {
        return JSON.parse(value);
      } catch (e) {}
    }

    return value as T | undefined;
  }

  remove() {
    const { key } = this;

    JSCookie.remove(key, {
      domain: this.getDomain(),
    });
  }
}

const effectiveHostsCookie = new Cookie<string[]>('hosts', {
  expires: YEAR,
  isGlobal: true,
  isJson: true,
});

export default effectiveHostsCookie;
